import React, { Component } from 'react';
import AuthService from './AuthService';

export default function withAuth(AuthComponent) {
    const Auth = new AuthService('http://localhost:8080');
    return class AuthWrapped extends Component {
        constructor(props) {
            super(props);
            this.state = {
                user: null
            }
        }
        componentWillMount() {
            if (!Auth.loggedIn()) {
                this.props.history.replace('/login')
            }
            else {
                try {
                    if (Auth.lock()) {
                        this.props.history.replace('/lock')
                    }
                    else {

                        const profile = Auth.getProfile();

                        this.setState({
                            user: profile
                        })
                    }

                }
                catch(err){
                    Auth.logout();
                    this.props.history.replace('/login');
                }
            }
        }

        render() {
            if (this.state.user) {
                return (
                    <AuthComponent history={this.props.history} user={this.state.user} location={this.props.location}/>
                )
            }
            else {
                return null
            }
        }
    };
}




// WEBPACK FOOTER //
// ./src/components/withAuth.js